import { useMsal } from '@azure/msal-react';

interface Props {
  message: string;
  email?: string;
}

export function AccessDenied({ message, email }: Props) {
  const { instance } = useMsal();

  const handleSignOut = () => {
    void instance.logoutRedirect();
  };

  return (
    <div style={styles.wrap}>
      <div style={styles.card}>
        <h1 style={styles.title}>Access not yet granted</h1>
        <p style={styles.body}>{message}</p>
        {email ? <p style={styles.email}>Signed in as <strong>{email}</strong></p> : null}
        <button type="button" style={styles.button} onClick={handleSignOut}>
          Sign out
        </button>
      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  wrap: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#f3f4f6',
    fontFamily: 'system-ui, -apple-system, sans-serif',
  },
  card: {
    background: '#fff',
    padding: '2.5rem',
    borderRadius: '0.75rem',
    boxShadow: '0 10px 25px rgba(0,0,0,0.08)',
    width: '28rem',
    textAlign: 'center',
  },
  title: { fontSize: '1.4rem', fontWeight: 600, margin: '0 0 1rem', color: '#b91c1c' },
  body: { color: '#374151', margin: '0 0 1rem', lineHeight: 1.5 },
  email: { color: '#6b7280', fontSize: '0.9rem', margin: '0 0 1.5rem' },
  button: {
    padding: '0.6rem 1.25rem',
    background: '#374151',
    color: '#fff',
    border: 'none',
    borderRadius: '0.5rem',
    fontWeight: 500,
    cursor: 'pointer',
  },
};
